import { Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { Configuration } from "../../../../config";
import { BoxCenter, ResponsiveH6 } from "../../../../global/components";
import { useLastUrlPart } from "../../../../hooks";

export const InfoBannerContent: React.FC = () => {
  const lastUrlPart = useLastUrlPart();
  const { t } = useTranslation(lastUrlPart);

  return (
    <BoxCenter column>
      <ResponsiveH6 sx={{ mb: "12px" }}>
        {lastUrlPart === "asset-management"
          ? t(`header.title.${Configuration.tenantStyle}`)
          : t("header.title")}
      </ResponsiveH6>
      <Typography>
        {lastUrlPart === "asset-management"
          ? t(`header.subtitle.${Configuration.tenantStyle}`)
          : t("header.subtitle")}
      </Typography>
    </BoxCenter>
  );
};
